import * as React from 'react';

import loadables from '@containers/App/loadables';

import { useWishlistId } from './hooks/useWishlistId';

// TODO: remove but make sure mobile app uses the new /wishlist/shared/:sharedListId url at least 6 months
export const TemporaryWishlistRouting = () => {
  const { sharedListId } = useWishlistId();
  return sharedListId ? <loadables.WishList /> : <loadables.WishlistLists />;
};
